/* Sticksaver – omien osioiden toiminnot: video latautuu vasta painettaessa, kiinteä ostopalkki, Forms-ponnahdusikkunan tyylit. */
(() => {
  if (window.ssSticksaverLoaded) return;
  window.ssSticksaverLoaded = true;

  const ready = (fn) => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  };

  // Video: kansikuva ensin, itse video haetaan vasta kun toistonappia painetaan.
  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-ss-video-play]') : null;
    if (!button) return;
    const box = button.closest('[data-ss-video]');
    const template = box ? box.querySelector('template[data-ss-video-template]') : null;
    if (!box || !template) return;
    const fragment = template.content.cloneNode(true);
    const video = fragment.querySelector('video');
    box.querySelectorAll('img, svg, [data-ss-video-play], [data-ss-video-label]').forEach((el) => el.remove());
    box.appendChild(fragment);
    if (video) {
      const playing = video.play();
      if (playing && typeof playing.catch === 'function') playing.catch(() => {});
    }
  });

  // Shopify Forms -ponnahdusikkuna: sovellus piirtää lomakkeen omaan suljettuun puuhunsa (shadow DOM),
  // johon sivun tyylit eivät ulotu. Värit ja fontit menevät perille CSS-muuttujina (ss-sticksaver.css);
  // tässä lisätään samaan puuhun ne säännöt, joille sovelluksessa ei ole muuttujaa.
  const formsCss = `
    h2 { text-transform: uppercase !important; line-height: 1 !important; letter-spacing: 0.01em; margin: 0 0 12px !important; text-wrap: balance; }
    [class*="_textBody_"] { line-height: 1.4 !important; }
    [class*="_formHeader_"] { padding-inline: 14px; }
    button[type="submit"], [data-testid="btn-form-submit"] {
      font-family: var(--font-heading--family, 'Barlow Condensed', sans-serif) !important;
      font-weight: 800 !important; font-size: 20px !important; line-height: 1 !important;
      letter-spacing: 0.03em; text-transform: uppercase;
      transition: background-color 0.12s ease, transform 0.12s ease;
    }
    button[type="submit"]:hover, [data-testid="btn-form-submit"]:hover { background-color: #e6e6e6 !important; filter: none !important; opacity: 1 !important; }
    button[type="submit"]:active, [data-testid="btn-form-submit"]:active { transform: scale(0.98); }
    button[type="submit"]:focus-visible, [role="button"]:focus-visible { outline: 2px solid #ffffff; outline-offset: 3px; }
    [class*="_formDisclaimer_"], [class*="_formDisclaimer_"] p { font-size: 12px !important; line-height: 1.4 !important; }
    [class*="_formDisclaimer_"] { opacity: 0.78; }
    @media screen and (max-width: 490px) { [class*="_formContainer_"] { margin-inline: 12px !important; } }
  `;
  let formsSheet = null;
  const styleForms = (host) => {
    const root = host.shadowRoot;
    if (!root) return false;
    try {
      if (!formsSheet) {
        formsSheet = new CSSStyleSheet();
        formsSheet.replaceSync(formsCss);
      }
      if (!root.adoptedStyleSheets.includes(formsSheet)) root.adoptedStyleSheets = [...root.adoptedStyleSheets, formsSheet];
    } catch (error) {
      // Vanha selain ilman adoptedStyleSheets-tukea: tavallinen style-elementti.
      if (!root.querySelector('style[data-ss-forms]')) {
        const style = document.createElement('style');
        style.setAttribute('data-ss-forms', '');
        style.textContent = formsCss;
        root.appendChild(style);
      }
    }
    if (!host.ssFormsWatched) {
      host.ssFormsWatched = true;
      // Sovellus voi vaihtaa tyylilistansa, kun lomake siirtyy seuraavaan vaiheeseen: varmistetaan, että oma pysyy mukana.
      new MutationObserver(() => styleForms(host)).observe(root, { childList: true, subtree: true });
    }
    return true;
  };
  const watchForms = () => {
    const tryHost = (host, attempt = 0) => {
      if (styleForms(host) || attempt > 40) return;
      window.setTimeout(() => tryHost(host, attempt + 1), 250);
    };
    document.querySelectorAll('shopify-forms-embed').forEach((host) => tryHost(host));
    new MutationObserver((records) => {
      records.forEach((record) =>
        record.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && node.localName === 'shopify-forms-embed') tryHost(node);
        })
      );
    }).observe(document.body, { childList: true });
  };
  ready(watchForms);

  // Ostopalkki: näkyy, kun sivun oma ostonappi on vieritetty ohi. Lähettää teeman oman ostolomakkeen.
  ready(() => {
    const bar = document.querySelector('[data-ss-buybar]');
    if (!bar) return;
    const form = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;
    const target = form.querySelector('.product-form-buttons') || form;
    const submit = bar.querySelector('[data-ss-buybar-submit]');
    const priceOut = bar.querySelector('[data-ss-buybar-price]');
    const mainButton = form.querySelector('button[name="add"], .add-to-cart-button');

    // Huom. lomakkeessa on kenttä nimeltä "id", joten form.id palauttaisi kentän eikä tunnistetta: luetaan attribuutti.
    const formId = form.getAttribute('id');
    if (submit) {
      if (formId) submit.setAttribute('form', formId);
      else submit.addEventListener('click', () => (form.requestSubmit ? form.requestSubmit() : form.submit()));
    }

    const sync = () => {
      const source = document.querySelector('.product-details product-price .price');
      if (source && priceOut) priceOut.textContent = source.textContent.trim();
      if (submit && mainButton) submit.disabled = mainButton.disabled;
    };
    sync();
    document.addEventListener('variant:update', () => window.setTimeout(sync, 80));

    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[entries.length - 1];
        const passed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        bar.classList.toggle('is-visible', passed);
        bar.toggleAttribute('inert', !passed);
      },
      { threshold: 0 }
    );
    observer.observe(target);
  });
})();
